import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=51e27d99&scoped=true"
import script from "./AlertMessage.vue?vue&type=script&lang=ts"
export * from "./AlertMessage.vue?vue&type=script&lang=ts"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=51e27d99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e27d99",
  null
  
)

export default component.exports